import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "题材分类" },
  { to: "/rankings", label: "实时榜单" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const isActive = (to: string) => (to === "/" ? pathname === "/" : pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-50 w-full transition-colors duration-300">
      <div
        className={`border-b transition-all duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
          <Link to="/" className="group flex items-center gap-2.5" aria-label="羞羞漫画韩国首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-base text-background-50 shadow-sm transition-transform duration-300 group-hover:rotate-6">
              <i className="ri-book-open-line" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-lg font-black tracking-wide text-foreground-950">
                羞羞漫画<span className="text-primary-500">韩国</span>
              </span>
              <span className="mt-0.5 font-label text-[10px] tracking-widest text-foreground-400">
                MANHWA · 韩国漫画
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-100/70 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/rankings"
              className="hidden whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-fire-line text-base" aria-hidden="true"></i>
              看榜单
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
            >
              <i className={open ? "ri-close-line" : "ri-menu-3-line"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
            <nav className="flex flex-col gap-1" aria-label="移动端导航">
              {navLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`rounded-md px-3 py-2.5 text-sm transition-colors ${
                    isActive(item.to)
                      ? "bg-primary-100/70 font-medium text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}